import { render } from "./Account.vue?vue&type=template&id=08d9002a"
import script from "./Account.vue?vue&type=script&lang=js"
export * from "./Account.vue?vue&type=script&lang=js"

import exportComponent from "/home/jenkins/workspace/Deploy unapatitafeliz backend PROD/admin-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__